import React from "react";

const ButtonOutlined = (props: {label: string, icon?: string, action?: () => void, style?: React.CSSProperties, stylesText?: React.CSSProperties}) => {
    return (
        <div className="Services__Add" onClick={props.action} style={props.style}>
            <p className="Body2">
                {props.label}
            </p>
            {props.icon ?
                <i className={props.icon} />
            : null}
        </div>
    )
};

export default ButtonOutlined; 